import React from "react";

interface TabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  className?: string;
}

const Tab: React.FC<TabProps> = ({
  label,
  isActive,
  onClick,
  className = "",
}) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer py-2 px-[12px] md:px-[16px] rounded-full transition-colors ${
        isActive ? "bg-brand-default text-white" : "hover:bg-gray-100"
      } ${className}`}
    >
      {label}
    </div>
  );
};

export default Tab;
